<template>
  <div ref="maincontainerdiv" v-loading="loading" class="salestock-container">
    <div class="stocktyablecontainercustom">
      <div v-if="stocktablenoresidential" id="chart-sale-no-resi" class="charts-table-container nonresi-table" :class="'col-' + columnSizeView">
        <div class="container-download-table">
          <popoverBtn v-model="popover1" :button="false" activator="click" position="bottom-left" :time="1" :border="false">
            <template v-slot:popoverName><div class="download-table-icon"><font-awesome-icon icon="bars" /></div></template>
            <div class="container-download-table-options">
              <div class="download-option" @click="downloadStockTable('stocktable-noresi')">{{ $t('download-xlsx') }}</div>
              <div class="download-option" @click="printTableActionBrowser('chart-sale-no-resi')">{{ $t('print-chart') }}</div>
              <div class="download-separator"><hr></div>
              <div class="download-option" @click="printTableAction('chart-sale-no-resi', 'png', 'supply-overview-by-sqm')">{{ $t('download-png-image') }}</div>
              <div class="download-option" @click="printTableAction('chart-sale-no-resi', 'jpeg', 'supply-overview-by-sqm')">{{ $t('download-jpeg-image') }}</div>
              <div class="download-option" @click="printTableActionPDF('chart-sale-no-resi', 'supply-overview-by-sqm', 'landscape')">{{ $t('download-pdf-document') }}</div>
              <!-- <div class="download-separator"><hr></div>
              <div class="download-option download-option--disabled">Download CSV document</div>
              <div class="download-option download-option--disabled">Download XLS document</div> -->
            </div>
          </popoverBtn>
        </div>

        <div class="titletable mb-3">{{ $t('chartsData.supply-overview-demand') }}</div>
        <table class="brains-table2 noborders stocktable-noresi" aria-describedby="tablenostockresi">
          <thead>
            <tr>
              <th colspan="2" />
              <th scope="col">{{ stocktablenoresidentialbuckets[0] }}</th>
              <th scope="col">{{ stocktablenoresidentialbuckets[1] }}</th>
              <th scope="col">{{ stocktablenoresidentialbuckets[2] }}</th>
              <th scope="col">{{ stocktablenoresidentialbuckets[3] }}</th>
              <th scope="col">{{ stocktablenoresidentialbuckets[4] }}</th>
              <th scope="col">{{ $t('all') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="td-ma-bottom" rowspan="2">{{ $t('units2') }}</td>
              <td>{{ $t('supply') }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket1pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket2pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket3pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket4pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket5pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.totalpub, 0) : '-' }}</td>
            </tr>
            <tr class="m-bottom">
              <td>{{ $t('demand') }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket1pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket2pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket3pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket4pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket5pub, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.totalpub, 0) : '-' }}</td>
            </tr>
            <tr>
              <td class="td-ma-bottom" rowspan="2">%</td>
              <td>{{ $t('supply') }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket1percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket2percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket3percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket4percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket5percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.totalpercent, 0) : '-' }} %</td>
            </tr>
            <tr class="m-bottom">
              <td>{{ $t('demand') }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket1percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket2percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket3percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket4percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket5percent, 1) : '-' }} %</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.totalpercent, 0) : '-' }} %</td>
            </tr>
            <tr>
              <td class="td-ma-bottom" rowspan="2">{{ $t('esqm') }}</td>
              <td>{{ $t('supply') }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket1em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket2em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket3em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket4em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket5em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.totalem2, 0) : '-' }}</td>
            </tr>
            <tr class="m-bottom">
              <td>{{ $t('demand') }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket1em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket2em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket3em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket4em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket5em2, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.totalem2, 0) : '-' }}</td>
            </tr>
            <tr>
              <td class="td-ma-bottom" rowspan="2">€</td>
              <td>{{ $t('supply') }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket1price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket2price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket3price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket4price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket5price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.totalprice, 0) : '-' }}</td>
            </tr>
            <tr class="m-bottom">
              <td>{{ $t('demand') }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket1price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket2price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket3price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket4price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket5price, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.totalprice, 0) : '-' }}</td>
            </tr>
            <tr>
              <td class="td-ma-bottom" rowspan="2">{{ $t('sqm') }}</td>
              <td>{{ $t('supply') }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket1sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket2sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket3sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket4sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.bucket5sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential ? formatNumber(stocktablenoresidential.totalsqm, 0) : '-' }}</td>
            </tr>
            <tr class="m-bottom">
              <td>{{ $t('demand') }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket1sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket2sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket3sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket4sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket5sqm, 0) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.totalsqm, 0) : '-' }}</td>
            </tr>
            <tr>
              <td rowspan="2">{{ $t('tts-supply') }}</td>
              <td rowspan="2">{{ $t('demand') }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket1timeto, 1) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket2timeto, 1) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket3timeto, 1) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket4timeto, 1) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.bucket5timeto, 1) : '-' }}</td>
              <td>{{ !!stocktablenoresidential_demand ? formatNumber(stocktablenoresidential_demand.totaltimeto, 1) : '-' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="stocktableresidential.residential && stocktableresidential_demand.residential" id="chart-sale-resi-flat" class="charts-table-container" :class="'col-' + columnSizeView">
        <label id="saletable_flat_selector_wrapper" class="chart-div-selector-wrapper" style="margin-bottom: 6px; display: block">
          <select id="saletable_flat_selector" v-model="filterSupplyFlatOverview" name="saletable_flat_selector" class="form-control chart-div-selector">
            <option value="all">{{ $t('dataSelectors.all') }}</option>
            <option value="on">{{ $t('new') }}</option>
            <option value="2h">{{ $t('chartsData.2nd-hand') }}</option>
            <!-- <option value="units">Units</option>
            <option value="units_tts">Units TTS</option> -->
          </select>
        </label>

        <div class="container-download-table">
          <popoverBtn v-model="popover2" :button="false" activator="click" position="bottom-left" :time="1" :border="false">
            <template v-slot:popoverName><div class="download-table-icon"><font-awesome-icon icon="bars" /></div></template>
            <div class="container-download-table-options">
              <div class="download-option" @click="downloadStockTable('stocktable-flat')">{{ $t('download-xlsx') }}</div>
              <div class="download-option" @click="printTableActionBrowser('chart-sale-resi-flat')">{{ $t('print-chart') }}</div>
              <div class="download-separator"><hr></div>
              <div class="download-option" @click="printTableAction('chart-sale-resi-flat', 'png', 'supply-overview')">{{ $t('download-png-image') }}</div>
              <div class="download-option" @click="printTableAction('chart-sale-resi-flat', 'jpeg', 'supply-overview')">{{ $t('download-jpeg-image') }}</div>
              <div class="download-option" @click="printTableActionPDF('chart-sale-resi-flat', 'supply-overview', 'portrait')">{{ $t('download-pdf-document') }}</div>
              <!-- <div class="download-separator"><hr></div>
              <div class="download-option download-option--disabled">Download CSV document</div>
              <div class="download-option download-option--disabled">Download XLS document</div> -->
            </div>
          </popoverBtn>
        </div>

        <!-- Datos -->
        <div class="titletable">{{ $t('chartsData.supply-overview-flat') }}</div>
        <div class="stocktablestyles">
          <table class=" brains-table2 noborders stocktable-flat" aria-describedby="tablenostockfla">
            <thead>
              <tr>
                <th colspan="2" />
                <th>1 {{ $t('bed') }}</th>
                <th>2 {{ $t('bed') }}</th>
                <th>3 {{ $t('bed') }}</th>
                <th>4 {{ $t('bed') }}</th>
                <th>{{ $t('all') }}</th>
                <th>{{ $t('parking') }}</th>
                <th>{{ $t('storage') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td-ma-bottom" rowspan="2">{{ $t('units2') }}</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room1pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room2pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room3pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room4pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.totalpub, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.parking ? formatNumber(stocktableresidential.parking.totalpub, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.trasteros ? formatNumber(stocktableresidential.trasteros.totalpub, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room1pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room2pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room3pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room4pub, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.totalpub, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.parking ? formatNumber(stocktableresidential_demand.parking.totalpub, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.trasteros ? formatNumber(stocktableresidential_demand.trasteros.totalpub, 0) : '-' }}</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">%</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room1percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room2percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room3percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room4percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.totalpercent, 0) : '-' }} %</td>
                <td> - </td>
                <td> - </td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room1percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room2percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room3percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room4percent, 1) : '-' }} %</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.totalpercent, 0) : '-' }} %</td>
                <td> - </td>
                <td> - </td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">{{ $t('esqm') }}</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room1em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room2em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room3em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room4em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.totalem2, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.parking ? formatNumber(stocktableresidential.parking.totalem2, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.trasteros ? formatNumber(stocktableresidential.trasteros.totalem2, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room1em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room2em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room3em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room4em2, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.totalem2, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.parking ? formatNumber(stocktableresidential_demand.parking.totalem2, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.trasteros ? formatNumber(stocktableresidential_demand.trasteros.totalem2, 0) : '-' }}</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">€</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room1price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room2price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room3price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room4price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.totalprice, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.parking ? formatNumber(stocktableresidential.parking.totalprice, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.trasteros ? formatNumber(stocktableresidential.trasteros.totalprice, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room1price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room2price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room3price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room4price, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.totalprice, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.parking ? formatNumber(stocktableresidential_demand.parking.totalprice, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.trasteros ? formatNumber(stocktableresidential_demand.trasteros.totalprice, 0) : '-' }}</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">{{ $t('sqm') }}</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room1sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room2sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room3sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.room4sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat ? formatNumber(selectedFlat.totalsqm, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.parking ? formatNumber(stocktableresidential.parking.totalsqm, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.trasteros ? formatNumber(stocktableresidential.trasteros.totalsqm, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room1sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room2sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room3sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.room4sqm, 0) : '-' }}</td>
                <td>{{ !!selectedFlat_demand ? formatNumber(selectedFlat_demand.totalsqm, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && stocktableresidential_demand.parking ? formatNumber(stocktableresidential_demand.parking.totalsqm, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && stocktableresidential_demand.trasteros ? formatNumber(stocktableresidential_demand.trasteros.totalsqm, 0) : '-' }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('tts-supply') }}</td>
                <td rowspan="2">{{ $t('demand') }}</td>
                <td>{{ !!selectedFlatTime_demand ? formatNumber(selectedFlatTime_demand.mvmeses1b, 1) : '-' }}</td>
                <td>{{ !!selectedFlatTime_demand ? formatNumber(selectedFlatTime_demand.mvmeses2b, 1) : '-' }}</td>
                <td>{{ !!selectedFlatTime_demand ? formatNumber(selectedFlatTime_demand.mvmeses3b, 1) : '-' }}</td>
                <td>{{ !!selectedFlatTime_demand ? formatNumber(selectedFlatTime_demand.mvmeses4b, 1) : '-' }}</td>
                <td>{{ !!selectedFlatTime_demand ? formatNumber(selectedFlatTime_demand.mvmeses, 1) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.parking ? formatNumber(stocktableresidential_demand.parking.totalsqm, 0) : '-' }}</td>
                <td>{{ !!stocktableresidential_demand && !!stocktableresidential_demand.trasteros ? formatNumber(stocktableresidential_demand.trasteros.totalsqm, 0) : '-' }}</td>
              </tr>

              <tr v-if="stocktableresidential.netFlat">
                <td>{{ $t('net-word') }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.netFlat ? formatNumber(getNetRentEm2ByRoom(stocktableresidential.netFlat, 1), 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.netFlat ? formatNumber(getNetRentEm2ByRoom(stocktableresidential.netFlat, 2), 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.netFlat ? formatNumber(getNetRentEm2ByRoom(stocktableresidential.netFlat, 3), 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.netFlat ? formatNumber(getNetRentEm2ByRoom(stocktableresidential.netFlat, 4), 0) : '-' }}</td>
                <td>{{ !!stocktableresidential && !!stocktableresidential.netFlat ? formatNumber(totalNetRentEm2(stocktableresidential.netFlat), 2) : '-' }}</td>
                <td> - </td>
                <td> - </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="stocktableresidential.residential && stocktableresidential_demand.residential" id="chart-sale-resi-house" class="charts-table-container" :class="'col-' + columnSizeView">
        <label id="saletable_house_selector_wrapper" class="chart-div-selector-wrapper" style="margin-bottom: 6px; display: block">
          <select id="saletable_house_selector" v-model="filterSupplyHouseOverview" name="saletable_house_selector" class="form-control chart-div-selector">
            <option value="all">{{ $t('dataSelectors.all') }}</option>
            <option value="on">{{ $t('new') }}</option>
            <option value="2h">{{ $t('chartsData.2nd-hand') }}</option>
          </select>
        </label>

        <div class="container-download-table">
          <popoverBtn v-model="popover3" :button="false" activator="click" position="bottom-left" :time="1" :border="false">
            <template v-slot:popoverName><div class="download-table-icon"><font-awesome-icon icon="bars" /></div></template>
            <div class="container-download-table-options">
              <div class="download-option" @click="downloadStockTable('stocktable-house')">{{ $t('download-xlsx') }}</div>
              <div class="download-option" @click="printTableActionBrowser('chart-sale-resi-house')">{{ $t('print-chart') }}</div>
              <div class="download-separator"><hr></div>
              <div class="download-option" @click="printTableAction('chart-sale-resi-house', 'png', 'supply-overview')">{{ $t('download-png-image') }}</div>
              <div class="download-option" @click="printTableAction('chart-sale-resi-house', 'jpeg', 'supply-overview')">{{ $t('download-jpeg-image') }}</div>
              <div class="download-option" @click="printTableActionPDF('chart-sale-resi-house', 'supply-overview', 'portrait')">{{ $t('download-pdf-document') }}</div>
            </div>
          </popoverBtn>
        </div>

        <!-- Datos -->
        <div class="titletable">{{ $t('chartsData.supply-overview-house') }}</div>
        <div class="stocktablestyles">
          <table class="brains-table2 noborders stocktable-house" aria-describedby="tablenostockhouse">
            <thead>
              <tr>
                <th colspan="2" />
                <th>1 {{ $t('bed') }}</th>
                <th>2 {{ $t('bed') }}</th>
                <th>3 {{ $t('bed') }}</th>
                <th>4 {{ $t('bed') }}</th>
                <th>{{ $t('all') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="td-ma-bottom" rowspan="2">{{ $t('units2') }}</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room1pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room2pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room3pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room4pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.totalpub, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room1pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room2pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room3pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room4pub, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.totalpub, 0) : '-' }}</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">%</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room1percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room2percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room3percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room4percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.totalpercent, 0) : '-' }} %</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room1percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room2percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room3percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room4percent, 1) : '-' }} %</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.totalpercent, 0) : '-' }} %</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">{{ $t('esqm') }}</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room1em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room2em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room3em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room4em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.totalem2, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room1em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room2em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room3em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room4em2, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.totalem2, 0) : '-' }}</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">€</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room1price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room2price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room3price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room4price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.totalprice, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room1price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room2price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room3price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room4price, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.totalprice, 0) : '-' }}</td>
              </tr>
              <tr>
                <td class="td-ma-bottom" rowspan="2">{{ $t('sqm') }}</td>
                <td>{{ $t('supply') }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room1sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room2sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room3sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.room4sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse ? formatNumber(selectedHouse.totalsqm, 0) : '-' }}</td>
              </tr>
              <tr class="m-bottom">
                <td>{{ $t('demand') }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room1sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room2sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room3sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.room4sqm, 0) : '-' }}</td>
                <td>{{ !!selectedHouse_demand ? formatNumber(selectedHouse_demand.totalsqm, 0) : '-' }}</td>
              </tr>
              <tr>
                <td rowspan="2">{{ $t('tts-supply') }}</td>
                <td rowspan="2">{{ $t('demand') }}</td>
                <td>{{ !!selectedHouseTime_demand ? formatNumber(selectedHouseTime_demand.mvmeses1b, 1) : '-' }}</td>
                <td>{{ !!selectedHouseTime_demand ? formatNumber(selectedHouseTime_demand.mvmeses2b, 1) : '-' }}</td>
                <td>{{ !!selectedHouseTime_demand ? formatNumber(selectedHouseTime_demand.mvmeses3b, 1) : '-' }}</td>
                <td>{{ !!selectedHouseTime_demand ? formatNumber(selectedHouseTime_demand.mvmeses4b, 1) : '-' }}</td>
                <td>{{ !!selectedHouseTime_demand ? formatNumber(selectedHouseTime_demand.mvmeses, 1) : '-' }}</td>
              </tr>

              <tr>
                <td v-if="stocktableresidential.netHouse">{{ $t('net-word') }}</td>
                <td>{{ !!stocktableresidential ? formatNumber(getNetYieldByRoom(stocktableresidential.netHouse, 1), 2) : '-' }} %</td>
                <td>{{ !!stocktableresidential ? formatNumber(getNetYieldByRoom(stocktableresidential.netHouse, 2), 2) : '-' }} %</td>
                <td>{{ !!stocktableresidential ? formatNumber(getNetYieldByRoom(stocktableresidential.netHouse, 3), 2) : '-' }} %</td>
                <td>{{ !!stocktableresidential ? formatNumber(getNetYieldByRoom(stocktableresidential.netHouse, 4), 2) : '-' }} %</td>
                <td>{{ !!stocktableresidential ? formatNumber(totalNetYield(stocktableresidential.netHouse), 2) : '-' }} %</td>
                <td> - </td>
                <td> - </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { printTable, printTablePDF, printTableBrowser } from '@/utils/chartutils'
import popoverBtn from '@/components/designComponents/popoverBtn'
import { mapState } from 'vuex'
export default {
  name: 'Stocktable',
  components: {
    popoverBtn
  },
  props: {
    options: { type: Object, default: null }
  },
  data() {
    return {
      loading: false,
      columnSizeView: 12,
      popover1: false,
      popover2: false,
      popover3: false,
      filterSupplyHouseOverview: 'all',
      filterSupplyFlatOverview: 'all',
      selectedResidential: [],
      selectedHouse: [],
      selectedFlat: [],
      selectedResidentialTime: [],
      selectedHouseTime: [],
      selectedFlatTime: [],
      selectedResidential_demand: [],
      selectedHouse_demand: [],
      selectedFlat_demand: [],
      selectedResidentialTime_demand: [],
      selectedHouseTime_demand: [],
      selectedFlatTime_demand: []
    }
  },
  computed: {
    ...mapState('charts', {
      chartsection: (state) => state.chartsection
    }),
    stocktablenoresidential: function() {
      return this.options.stocktablenoresidential
    },
    stocktableresidential: function() {
      return this.options.stocktableresidential
    },
    stocktablenoresidential_demand: function() {
      return this.options.stocktablenoresidential_demand
    },
    stocktableresidential_demand: function() {
      return this.options.stocktableresidential_demand
    },
    stocktablenoresidentialbuckets: function() {
      return this.options.stocktablenoresidentialbuckets
    }
  },
  watch: {
    chartsection: function() {
      this.selectedSupplyHouseOverview()
      this.selectedSupplyFlatOverview()
    },
    filterSupplyHouseOverview: function() {
      this.selectedSupplyHouseOverview()
    },
    filterSupplyFlatOverview: function() {
      this.selectedSupplyFlatOverview()
    },
    loading(newOne, oldOne) {
      if (!newOne) {
        this.setContainerSizes()
      }
    }
  },
  mounted() {
    this.selectedSupplyHouseOverview()
    this.selectedSupplyFlatOverview()
    console.log(this)
  },
  methods: {
    totalNetRent(allNets) {
      if (allNets === null || allNets === undefined) { return '-' }
      var total = 0
      allNets.forEach(item => {
        total += item.net_rent
      })

      return total / allNets.length
    },
    getNetRentByRoom(net, room) {
      if (net === null || net === undefined) { return '-' }
      var result = net.filter(item => { return item.rooms === room })

      if (result.length >= 1) {
        return result[0].net_rent
      }
    },
    totalNetRentEm2(allNets) {
      if (allNets === null || allNets === undefined) { return '-' }
      var total = 0
      allNets.forEach(item => {
        total += item.net_em2
      })

      return total / allNets.length
    },
    getNetRentEm2ByRoom(net, room) {
      if (net === null || net === undefined) { return '-' }
      var result = net.filter(item => { return item.rooms === room })

      if (result.length >= 1) {
        return result[0].net_em2
      }
    },
    totalNetYield(allNets) {
      if (allNets === null || allNets === undefined) { return '-' }
      var total = 0
      allNets.forEach(item => {
        total += item.net_yield
      })

      return total / allNets.length
    },
    getNetYieldByRoom(net, room) {
      if (net === null || net === undefined) { return '-' }
      var result = net.filter(item => { return item.rooms === room })

      if (result.length >= 1) {
        return result[0].net_yield
      }
    },
    selectedSupplyHouseOverview() {
      if (this.filterSupplyHouseOverview === 'on') {
        this.selectedHouse = this.stocktableresidential.houseON
        this.selectedHouse_demand = this.stocktableresidential_demand.houseON
        this.selectedHouseTime = this.stocktableresidential.houseTimeON
        this.selectedHouseTime_demand = this.stocktableresidential_demand.houseTimeON
      } else if (this.filterSupplyHouseOverview === '2h') {
        this.selectedHouse = this.stocktableresidential.house2H
        this.selectedHouse_demand = this.stocktableresidential_demand.house2H
        this.selectedHouseTime = this.stocktableresidential.houseTime2H
        this.selectedHouseTime_demand = this.stocktableresidential_demand.houseTime2H
      } else {
        this.selectedHouse_demand = this.stocktableresidential_demand.house
        this.selectedHouse = this.stocktableresidential.house
        this.selectedHouseTime = this.stocktableresidential.houseTime
        this.selectedHouseTime_demand = this.stocktableresidential_demand.houseTime
      }
    },
    selectedSupplyFlatOverview() {
      if (this.filterSupplyFlatOverview === 'on') {
        this.selectedFlat_demand = this.stocktableresidential_demand.flatON
        this.selectedFlat = this.stocktableresidential.flatON
        this.selectedFlatTime_demand = this.stocktableresidential_demand.flatTimeON
        this.selectedFlatTime = this.stocktableresidential.flatTimeON
      } else if (this.filterSupplyFlatOverview === '2h') {
        this.selectedFlat_demand = this.stocktableresidential_demand.flat2H
        this.selectedFlat = this.stocktableresidential.flat2H
        this.selectedFlatTime_demand = this.stocktableresidential_demand.flatTime2H
        this.selectedFlatTime = this.stocktableresidential.flatTime2H
      } else {
        this.selectedFlat_demand = this.stocktableresidential_demand.flat
        this.selectedFlat = this.stocktableresidential.flat
        this.selectedFlatTime_demand = this.stocktableresidential_demand.flatTime
        this.selectedFlatTime = this.stocktableresidential.flatTime
      }
    },
    setContainerSizes() {
      setTimeout(() => {
        var charts = document.querySelectorAll('.highchart--resize')
        charts.forEach(chart => {
          var width = chart.childNodes[0].clientWidth
          var height = chart.childNodes[0].clientHeight
          chart.childNodes[0].style.maxWidth = width + 'px'
          chart.childNodes[0].style.maxHeight = height + 'px'
        })
      }, 2000)
    },
    downloadStockTable(tableClass) {
      this.closePopovers()
      this.downloadGenericTable(tableClass)
    },
    printTableAction(idContainerPrint, typePrint, name) {
      this.closePopovers()
      setTimeout(() => {
        printTable(idContainerPrint, typePrint, name)
      }, 500)
    },
    printTableActionPDF(idContainerPrint, name, direction) {
      this.closePopovers()
      setTimeout(() => {
        printTablePDF(idContainerPrint, name, direction)
      }, 500)
    },
    printTableActionBrowser(idContainerPrint) {
      this.closePopovers()
      setTimeout(() => {
        printTableBrowser(idContainerPrint)
      }, 500)
    },
    formatNumber(num, decimals) {
      if (num === null || num === undefined || parseFloat(num) === 0) { return '-' }
      if (decimals === null || decimals === undefined || decimals === 0) { return num.toLocaleString('it-IT', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }
      if (decimals === 1) { return num.toLocaleString('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) }
      return num.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  }
}
</script>

<style lang="scss" scoped>

.stocktyablecontainercustom {
  height: 100% !important;
}
.stocktablestyles {
  max-width: 100%;
  overflow: scroll;
}

.charts-table-container {
  position: relative;

   .titletable {
     margin-top: 25px;
   }

   table {
     width: 90%;
     margin: 30px auto;
     font-size: 0.9em;

     tr:nth-child(2n - 1) td:first-child {
       font-weight: bold;
       padding: 7px 5px 7px 5px;
     }
   }
}

.salestock-container {
  height: 100%  !important;
  // overflow-y: scroll;
  width: 100%;
  background-color: #f9f9f9;
}

.col-6 div {
  transform: scale(0.9);
  border: 1px solid lightgray;
  background-color: white;
}

.tablebrains {
  font-family: "Montserrat",sans-serif;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 0.5rem;
  margin-right: auto;
  margin-left: auto;
  width: 90%;
}

.tablebrains .rowtitle {
  font-weight: 800;
}

.tablebrains thead th,
.tablebrains tbody th {
  width: 90px;
  min-width: 2px;
  text-align: center;
}

.tablebrains thead tr th:first-child {
  text-align: left;
  max-width: 91px;
  width: 91px;
  min-width: 1px;
}

.titletable {
  text-align: center;
  font-family: "Montserrat-Regular",sans-serif;
  text-decoration: underline;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 12pt !important;
}

.tablebrains tbody tr th {
  text-align: left;
}

.tablebrains th,
.table td {
  padding: 0.2rem;
  border-top: unset;
  vertical-align: middle;
  width: 90px;
  text-align: center;
}

.tableicon {
  width: 16px;
  height: 8.5px;
}

.thead-brains {
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
  margin-bottom: 2px;
}

.tabletitle {
  font-size: 1em !important;
  font-family: "Montserrat",sans-serif;
}

.graphtitlenodata {
  font-size: 1em !important;
  font-family: "Montserrat",sans-serif;
}

.rowtitle {
  background-color: #1e3cff;
}

.residentialicon {
  width: 22px;
  height: 16px;
}

.houseicon {
  width: 16px;
  height: 16px;
}

.flaticon {
  width: 16px;
  height: 16px;
}

.el-row {
  margin-right: 0px !important;
}

.scrolldown_arrow {
  position: absolute;
  bottom: 20px;
  left: 49.1%;
  width: 18px;
  height: 18px;
  border-radius: 20px;
  background-color: #1e3cff;
  color: white;
  text-align: center;
  transform: scale(2.5);
}

.scrolldown_arrow:hover {
  cursor: pointer;
}

.container-table-responsive {
  padding-bottom: 10px;
}

.container-table-responsive--first {
  padding-bottom: 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  /* height: 89vh; */
  margin-top: -10px;
}

.first-chart-mt {
  margin-top: 12px;
  margin-bottom: 21px;
}

.table-supply-overview-by-sqm {
  min-height: 400px;
  margin-top: 13px;
  padding-top: 15px;
}

.premium-view-resize-elem--first {
  margin-bottom: 0;
}

.premium-view-resize-elem--second {
  margin-top: -2px;
}

#img-preview-marketrecoverytransprice {
  background-image: url("/images/preview-charts/market-recovery-trans-prices-preview.png");
}

#img-preview-marketrecoveryfomento {
  background-image: url("/images/preview-charts/market-recovery-units-preview.png");
}
</style>
